import { render } from "./BaseRadio.vue?vue&type=template&id=d085766a"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
script.render = render

export default script